import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locals/en'
import zh from './locals/zh'

Vue.use(VueI18n)

// 配置语言翻译表
const messages = {
  en: en,
  zh: zh
}

// 检测用户默认语言
const userLanguage = localStorage.getItem('language') || (navigator.language.includes('zh') ? 'zh' : 'en')

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: userLanguage, // 默认语言
  fallbackLocale: 'en', // 回退语言
  messages // 翻译内容
})

export default i18n
